import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountCityPipe } from './account-city.pipe';
import { AccountPhonePipe } from './account-phone.pipe';
import { DigitalAgentNamePipe } from './digital-agent-name.pipe';
import { GetAccountInfoPipe } from './get-account-info.pipe';
import { GetProductInfoPipe } from './get-product-info.pipe';
import { ProjectStatusOptionPipe } from './project-status-option.pipe';
import { DisplayFulfillmentOrderStatusPipe } from './display-fulfillment-order-status.pipe';

const pipes = [
  AccountCityPipe,
  AccountPhonePipe,
  DigitalAgentNamePipe,
  GetAccountInfoPipe,
  GetProductInfoPipe,
  ProjectStatusOptionPipe,
  DisplayFulfillmentOrderStatusPipe,
];

@NgModule({
  declarations: pipes,
  imports: [CommonModule],
  exports: pipes,
  providers: pipes,
})
export class FulfillmentOrderPipesModule {}
